import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RackingInspectionQuestion, resetRackingInspectionQuestionsCache } from "../../components/racking_inspection/fetchRackingInspectionQuestions";

interface RackingInspectionQuestionsState {
  questions: RackingInspectionQuestion[];
  loading: boolean;
  error: string | null;
  successMessage: string | null;
}

const initialState: RackingInspectionQuestionsState = {
  questions: [],
  loading: false,
  error: null,
  successMessage: null,
};

const rackingInspectionQuestionsSlice = createSlice({
  name: "rackingInspectionQuestions",
  initialState,
  reducers: {
    setQuestions: (
      state,
      action: PayloadAction<RackingInspectionQuestion[]>
    ) => {
      state.questions = action.payload;
      state.loading = false;
      state.error = null;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
      state.loading = false;
    },
    clearQuestions: (state) => {
      state.questions = [];
      state.error = null;
      state.loading = false;
      // Reset the module-level cache to allow fresh API calls
      resetRackingInspectionQuestionsCache();
    },
    setSuccessMessage: (state, action: PayloadAction<string | null>) => {
      state.successMessage = action.payload;
    },
    clearSuccessMessage: (state) => {
      state.successMessage = null;
    },
  },
});

export const {
  setQuestions,
  setLoading,
  setError,
  clearQuestions,
  setSuccessMessage,
  clearSuccessMessage,
} = rackingInspectionQuestionsSlice.actions;

export default rackingInspectionQuestionsSlice.reducer;
